import { render, staticRenderFns } from "./ApplicantSideNavComponentV2.vue?vue&type=template&id=e2a79f3c&"
import script from "./ApplicantSideNavComponentV2.vue?vue&type=script&lang=ts&"
export * from "./ApplicantSideNavComponentV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2a79f3c')) {
      api.createRecord('e2a79f3c', component.options)
    } else {
      api.reload('e2a79f3c', component.options)
    }
    module.hot.accept("./ApplicantSideNavComponentV2.vue?vue&type=template&id=e2a79f3c&", function () {
      api.rerender('e2a79f3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Applicant/ApplicantSideNavComponentV2.vue"
export default component.exports